export function LinesHighlighter({
  content,
  aiEdits,
}: {
  aiEdits: { l: string; v: string }[];
  content: string;
}) {
  let maxCount = aiEdits.reduce((max, edit) => {
    return Math.max(max, parseInt(edit.l));
  }, 0);
  let lines = content.split("\n");
  return (
    <div
      style={{
        position: "absolute",
        width: "100%",
        padding: "20px 20px",
        // zIndex: 9999999,
      }}
    >
      {lines.map((line, index) => {
        let isEdited = aiEdits.find((edit) => edit.l === index?.toString());
        const isDeleted =
          isEdited?.v?.toLowerCase() === "deleted" ||
          isEdited?.v?.toLowerCase() === "deleted-";
        return (
          <div
            key={index}
            style={{
              backgroundColor: isDeleted
                ? "rgba(255, 0, 0, 0.4)"
                : isEdited
                ? "rgba(20, 255, 20, 0.4)"
                : "transparent",
              width: "100%",
              color: "transparent",
            }}
            dangerouslySetInnerHTML={{
              __html: `${line}\n`,
            }}
          >
            {/* {line} */}
          </div>
        );
      })}
    </div>
  );
}
